 
import Pricing from "../Price/Pricing";
import axios from "axios";
import { useState } from "react";
import GoogleMap from "./GoogleMap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactPageContents = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await axios.post(
      "https://shreegita.com/contact.php",
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.status === "success") {
      toast.success("Message sent successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    } else {
      toast.error(response.data.message || "Something went wrong.");
    }
  } catch (error) {
    console.error("Submission Error:", error);
    toast.error("Failed to send message. Please try again later.");
  }
};


  return (
    <>
      <div className="contact-us-wrapper section-padding">
        <div className="container">
          <div className="row eq-height">
            <div className="col-lg-6 col-12">
              <div className="contact-form">
                <h2>Get in Touch</h2>
                <form className="row" id="contact-form" onSubmit={handleSubmit}>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <input
                        type="text"
                        name="phone"
                        placeholder="Number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="single-personal-info">
                      <input
                        type="text"
                        name="subject"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-12">
                    <div className="single-personal-info">
                      <textarea
                        name="message"
                        placeholder="Message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-12">
                    <input className="submit-btn" type="submit" value="Submit Now" />
                  </div>
                </form>
              </div>
            </div>

            <div className="col-lg-6 col-12">
              <div className="contact-us-sidebar mt-5 mt-lg-0">
                <div className="contact-info">
                  <h2>CONTACT INFO</h2>
                  <div className="single-info">
                    <div className="icon">
                      <i className="flaticon-email" />
                    </div>
                    <div className="text">
                      <span>Email Us</span>
                      <h5>
                        <a href="mailto:info@shreegita.com">info@shreegita.com</a>
                      </h5>
                    </div>
                  </div>
                  <div className="single-info">
                    <div className="icon">
                      <i className="flaticon-phone-call-1" />
                    </div>
                    <div className="text">
                      <span>Call Us</span>
                      <h5>
                        <a href="tel:+917600048000">+91-7600048000</a>
                        <br />
                        {/* <a href="tel:+912822250246">+91-2822–250246</a> */}
                      </h5>
                    </div>
                  </div>
                  <div className="single-info">
                    <div className="icon">
                      <i className="flaticon-pin" />
                    </div>
                    <div className="text">
                      <span>Location</span>
                      <h5>Panchasar Road, Morbi–363641, Guj. INDIA</h5>
                    </div>
                  </div>
                </div>

                <div className="live-chat pt-5">
                  <div className="footer-social-icon d-flex justify-content-around">
                    <a
                      href="https://www.facebook.com/pages/Shree-Gita/167373366644608/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/shree-gita-group/posts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin"></i>

                    </a>
                    <a
                      href="https://www.instagram.com/shreegitaoil/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                    {/* <a
                      href="https://www.pinterest.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-pinterest-p"></i>
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Pricing />
      {/* <GoogleMap /> */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
};

export default ContactPageContents;
